export default __webpack_public_path__ + "static/media/batman-crop.d29db306.jpg";